import * as constants from "./constants";

const initialState = {
  allLabStatuses: [],
  fetchingLoading: true,
  updateLoading: false,
  totalRecords: 0,
  isAdding: false,
};

const labStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.CREATE_LAB_STATUSES:
      return {
        ...state,
        updateLoading: true,
      };
    case constants.CREATE_LAB_STATUSES_SUCCESS:
      return {
        ...state,
        updateLoading: false,
        allLabStatuses: [...state.allLabStatuses, action.data],
        isAdding: false,
      };
    case constants.CREATE_LAB_STATUSES_ERROR:
      return {
        ...state,
        updateLoading: false,
        isAdding: false,
      };

    case constants.UPDATE_ORDER:
      return {
        ...state,
        fetchingLoading: true,
      };
    case constants.UPDATE_ORDER_SUCCESS:
      return {
        ...state,
        fetchingLoading: false,
        allLabStatuses: action.data,
      };
    case constants.UPDATE_ORDER_ERROR:
      return {
        ...state,
        fetchingLoading: false,
      };

    case constants.FETCH_LAB_STATUSES:
      return {
        ...state,
        fetchingLoading: true,
      };
    case constants.FETCH_LAB_STATUSES_SUCCESS:
      return {
        ...state,
        fetchingLoading: false,
        allLabStatuses: action.data,
        isAdding: false,
      };
    case constants.FETCH_LAB_STATUSES_ERROR:
      return {
        ...state,
        fetchingLoading: false,
        isAdding: false,
      };
    case constants.UPDATE_LAB_STATUSES:
      return {
        ...state,
        updateLoading: true,
      };
    case constants.UPDATE_LAB_STATUSES_SUCCESS:
      const updated = state.allLabStatuses.map((el) =>
        el.id === action.data.id ? { ...el, ...action.data } : el
      );
      return {
        ...state,
        allLabStatuses: updated,
        updateLoading: false,
        isAdding: false,
      };
    case constants.UPDATE_LAB_STATUSES_ERROR:
      return {
        ...state,
        updateLoading: false,
        isAdding: false,
      };
    case constants.DELETE_LAB_STATUSES:
      return {
        ...state,
        updateLoading: true,
        isAdding: false,
      };
    case constants.DELETE_LAB_STATUSES_SUCCESS:
      const updatedData = state.allLabStatuses.filter(
        (el) => el.id !== action.data
      );
      return {
        ...state,
        allLabStatuses: updatedData,
        updateLoading: false,
        isAdding: false,
      };
    case constants.DELETE_LAB_STATUSES_ERROR:
      return {
        ...state,
        updateLoading: false,
        isAdding: false,
      };
    case constants.IS_ADDING_UPDATE:
      return {
        ...state,
        isAdding: action.data,
      };

    default:
      return state;
  }
};

export default labStatusReducer;
